export const CHAT_PAGE_PATH = '/';

export const ADMIN_USERS = [
  'sharon.macmonagle@allianzretireplus.com.au',
  'stephen.k.ung@allianzretireplus.com.au',
  'catherine.vanderveen@allianzretireplus.com.au',
  'lucy.foster@allianzretireplus.com.au',
  'peng.cao@v2.ai',
  'nick.hunt@v2.ai',
  'rhys.deimel@v2.ai',
];

export const SUPER_ADMIN_USER = ['peng.cao@v2.ai'];

export const MANAGEMENT_ROUTES = [
  '/dashboard',
  '/conversations',
  '/document-usage',
  '/feedback-statistics',
  '/feedback-global',
  '/test-results',
];

export const FILENAME_TO_SHORTNAME_MAP: Record<string, string> = {
  'AGILE_Product_Disclosure_Statement.pdf': 'Agile PDS',
  'AGILE_Target_Market_Determination_November_2024.pdf': 'Agile TMD',
  'AGILE_guaranteed_minimums_v1_August_2025.pdf': 'Agile Guaranteed Minimums',
  'AGILE_lifetime_income_rates_August_2025.pdf': 'Agile Lifetime Income Rates',
  'AGILE_maximum_returns_v1_August_2025.pdf': 'Agile Maximum Returns',
  'Client_and_member_FAQs_FINAL.docx': 'Agile Website FAQ',

  'Guaranteed_minimum_sept_2025.txt': 'AGILE Guaranteed Minimums (Sept)',
  'Lifetime_income_rates_sept_2025-v2.txt':
    'AGILE Lifetime Income Rates (Sept 2025)',
  'Maximum_Returns_Sept_2025_enhanced.txt': 'AGILE Maximum Returns (Sept 2025)',
  'Guaranteed_minimum_sept_2025_enhanced.txt':
    'AGILE Guaranteed Minimums (Sept 2025)',
  'Lifetime_income_rates_sept_2025_enhanced.csv':
    'AGILE Lifetime Income Rates (Sept 2025)',
};

// Landing page copy, signed off by Allianz on the ADA-144 deck. Kept here
// rather than inline in the components so tests/unit/landingCopy.test.ts can
// assert it without a DOM.
export const ADA_TAGLINE = 'Ada, your Adviser Digital Assistant';

export const CHAT_PLACEHOLDER = 'What would you like to know today?';

export const CHAT_PLACEHOLDER_MOBILE = 'Ask Ada...';

export const SUPER_PLUS_EXPLAINER =
  'Is your client looking to invest non-super money? Or invest super money via a platform or trust? Ask about AGILE. For individual super investments off-platform, ask about AGILE Super+.';

// FAQ Questions for Welcome Screen
export const FAQ_QUESTIONS = {
  NEW_USER: [
    'What is AGILE?',
    'What are the benefits of retirement products?',
    'What are the income rates?',
    'What are the fees?',
    'What is the difference between AGILE and AGILE Super+?',
  ],
  EXPERIENCED_USER: [
    'How are payments calculated?',
    'What happens if my client passes away?',
    "What are my client's Centrelink entitlements?",
    'Does a condition of release need to be met to invest?',
    'How much money should my client invest?',
  ],
};
